/**
 * @generated SignedSource<<7911a85dc57a852eff6ea696241671f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
import { FragmentRefs } from "relay-runtime";
export type jobApplication_useIsUnsentJobApplication$data = {
  readonly contract: {
    readonly id: string;
  } | null | undefined;
  readonly status: JobApplicationStatus;
  readonly " $fragmentType": "jobApplication_useIsUnsentJobApplication";
};
export type jobApplication_useIsUnsentJobApplication$key = {
  readonly " $data"?: jobApplication_useIsUnsentJobApplication$data;
  readonly " $fragmentSpreads": FragmentRefs<"jobApplication_useIsUnsentJobApplication">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "jobApplication_useIsUnsentJobApplication",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobApplication",
  "abstractKey": null
};

(node as any).hash = "bf73af951762ddcfa60cbf71ff64f91b";

export default node;
